export default __webpack_public_path__ + "static/media/interior design.b2969234.jpg";